import type { DomainGuide } from '@/components/guide/guide-types';

import th from './th.json';
import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';
import km from './km.json';
import lo from './lo.json';
import my from './my.json';

/**
 * Help catalog for the `site` domain — the operator's own brand settings.
 *
 * The Player theme card renders only on an `agent` row: `updateOrganization`
 * rejects branding + settings writes anywhere else (TEN-010 / TEN-013), so other
 * tiers see a pointer to the agent's Edit dialog instead. The Backoffice theme
 * card writes `theme` only, which is exempt from that rule and works everywhere.
 */
export const siteGuide: DomainGuide = {
  domain: 'site',
  pages: [
    {
      id: 'site.mySite',
      route: '/site',
      permission: 'site:manage',
      status: 'live',
      fields: [
        { key: 'displayName', kind: 'text' },
        { key: 'brandColors', kind: 'text' },
        { key: 'logos', kind: 'text' },
        { key: 'defaultLocale', kind: 'text' },
        { key: 'phoneCountry', kind: 'text' },
        { key: 'captchaEnabled', kind: 'status' },
        { key: 'chatwootToken', kind: 'text' },
        { key: 'lineId', kind: 'text' },
        { key: 'boTheme', kind: 'text' },
      ],
      cautionCount: 6,
      warningCount: 0,
    },
  ],
  copy: { th, en, zh, vi, km, lo, my },
};
